import { token } from '@atlaskit/tokens';
import { useLocale } from '@databases/intl';
import { DatabaseFieldType } from '@databases/types/database';
import { toDisplayDate } from '@databases/utils/database/field-types/date';
import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';

import { ViewComponentProps } from './types';

export const DateValueViewContainer = styled.span`
  background: ${token('color.background.neutral', '#091E420F')};
  border-radius: 3px;
  color: ${token('color.text', '#172B4D')};
  padding: ${token('space.025', '2px')} ${token('space.050', '4px')};
`;

const DateValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.DATE>> = ({
  value,
}) => {
  const locale = useLocale();

  const displayDate = useMemo(() => {
    if (!value) {
      return null;
    }

    let date = value;
    try {
      date = toDisplayDate(value, locale) ?? value;
      // eslint-disable-next-line canvas/no-swallow-errors-in-catch
    } catch (e) {
      /* empty */
    }

    return date;
  }, [value, locale]);

  if (!value) {
    return null;
  }

  return <DateValueViewContainer>{displayDate}</DateValueViewContainer>;
};

export default DateValueView;
